<template>
    <div class="d-flex flex-column align-items-center justify-content-center h-100 text-center">

            <div class="flex-grow-0">
                <div class="text-warning mb-3"><i class="fa fa-3x" :class="[ icon ]"> </i></div>
                <span class="h2">Ошибка {{ code }}</span>
            </div>
            <div class="flex-grow-1 mt-3">
                <span class="h5">
                    <slot name="message">
                    </slot>
                </span>
            </div>
            <div class="flex-grow-1 mt-3">
                <span>{{ text }}</span>
            </div>
            <div class="flex-grow-0 mt-5">
                <div class="form-group d-flex align-items-center justify-content-center">
                    <button class="btn btn-primary btn-block" @click="goBack">Вернуться</button>
                </div>

            </div>

    </div>
</template>

<script>

    export default {
        name: "Error",
        props: {
            code: undefined,
            text: undefined,
            icon: { type: String, default: 'fa-exclamation-triangle' }
        },
        methods: {
            goBack() {
                this.$router.go(-2);
            }
        }
    }

</script>

<style scoped>

</style>